import React from 'react';
import Form from 'react-bootstrap/Form';
import NeutralToggle from '../controls/NeutralToggle';
import { useForceUpdate, isValidURL } from '../util';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
import { TabContextReporter } from '../TabContext';
export default function AudioPlayer(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Audio Details"
  }, /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChwange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Audio Source:"), " ", /*#__PURE__*/React.createElement("i", null, "A direct link to the audio file.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.src,
    onChange: e => {
      dataProps.src = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidURL(dataProps.src)
  }, "Please enter a valid URL.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Subtitle Source:"), " ", /*#__PURE__*/React.createElement("i", null, "A direct link to the subtitle file.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.trackSource,
    onChange: e => {
      dataProps.trackSource = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidURL(dataProps.trackSource, true)
  }, "Please enter a valid URL.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Optional Completion:"), " ", /*#__PURE__*/React.createElement("i", null, "Whether the user is required to listen to the audio or not.")), /*#__PURE__*/React.createElement(NeutralToggle, {
    style: {
      display: 'block'
    },
    optionTrue: "Optional",
    optionFalse: "Required",
    value: dataProps.completed,
    onChange: v => {
      dataProps.completed = v;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: dataProps.completed === true || dataProps.completed === false
  }, "Please select an option.")))));
}